<template>
  <component :is="componentTag" />
</template>
<script>
import webFaq from "./web";
import mobileFaq from "./mobile";
export default {
  components: {
    webFaq,
    mobileFaq,
  },
  data() {
    return {
      isMobile: false,
      componentTag: "",
    };
  },
  created() {
    this.listenObserverWidth(750);
  },
  methods: {
    // 监听可视窗口宽度
    listenObserverWidth(mobileWidth) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentRect.width <= mobileWidth) {
            this.componentTag = "mobileFaq";
          } else {
            this.componentTag = "webFaq";
          }
        }
      });
      resizeObserver.observe(document.body);
    },
  },
};
</script>